import { type PayloadAction, createAction, createReducer } from '@reduxjs/toolkit';
import { setUserName } from 'reactApp/modules/user/user.actions';
import type { SetUserNameAction } from 'reactApp/modules/user/user.types';

import type { VK_MUSIC_BUNDLE_SOURCE } from './vkMusic.const';
import type { VKIDInfo, VkMusicBundleInfo, VkMusicBundleState, VkMusicBundleTariffInfo } from './vkMusic.types';

const initialState: VkMusicBundleState = {
    fullName: '',
    vkid: '',

    data: {
        isLoaded: false,
        isLoading: false,
        canOffer: false,
    },
};

export interface BuyVkMusicBundleAction {
    tariffInfo: VkMusicBundleTariffInfo;
    vkid: VKIDInfo;
    needConfirm: boolean;
    source: VK_MUSIC_BUNDLE_SOURCE;
}

export interface BuyVkMusicBundleChooseAction {
    baseTariffInfo: VkMusicBundleTariffInfo;
    baseVKID: VKIDInfo | null;
    onChoose?: () => void;
    needConfirm?: boolean;
    source: VK_MUSIC_BUNDLE_SOURCE;
}

export interface SetVkMusicBundleVKIDAction {
    vkid: string;
}

const buyVkMusicBundle = createAction<BuyVkMusicBundleAction>('vkMusicBundle/buyVkMusicBundle');
const buyVkMusicBundleChoose = createAction<BuyVkMusicBundleChooseAction>('vkMusicBundle/buyVkMusicBundleChoose');
const setVkMusicBundleVKID = createAction<SetVkMusicBundleVKIDAction>('vkMusicBundle/setVkMusicBundleVKID');
const loadVkMusicBundleInfo = createAction('vkMusicBundle/loadVkMusicBundleInfo');
const getVkMusicBundleInfoSuccess = createAction<VkMusicBundleInfo>('vkMusicBundle/getVkMusicBundleInfoSuccess');

export const vkMusicBundleReducer = createReducer(initialState, {
    [setVkMusicBundleVKID.type]: (state, { payload: { vkid } }: PayloadAction<SetVkMusicBundleVKIDAction>) => {
        state.vkid = vkid;
    },
    [loadVkMusicBundleInfo.type]: (state) => {
        state.data.isLoaded = false;
        state.data.isLoading = true;
    },
    [getVkMusicBundleInfoSuccess.type]: (state, { payload }: PayloadAction<VkMusicBundleInfo>) => {
        state.data = { ...payload, isLoaded: true, isLoading: false };
    },
    [setUserName.type]: (state, action: PayloadAction<SetUserNameAction>) => {
        state.fullName = action.payload.fullName;
    },
});

export const VkMusicBundleActions = {
    buyVkMusicBundle,
    buyVkMusicBundleChoose,
    setVkMusicBundleVKID,
    getVkMusicBundleInfoSuccess,
    loadVkMusicBundleInfo,
} as const;
